import React from 'react';
import styled, { css } from 'styled-components';
import { Block } from 'src/components/LayoutBase';
import { getBrandingColor, colorTypes } from 'src/branding';
import { ItemTable } from 'src/styles/commonStyledComponents';

import {
  RenderPartHightlightMatch,
  DropdownItem,
} from 'src/components/SearchableDropdown';
import { ChoiceButton } from 'src/components/Input';
import {
  Cell,
  Column,
  LinkLabel,
  Icon,
} from '../../components/Layout';

export const Animal = styled.div`
  margin-bottom: 0.8rem;
  width: 100%;
`;
export const AnimalGroup = styled(Block)``;
export const AnimalGroupHeader = styled(LinkLabel)`
  font-size: 1.5rem;
  font-weight: 500;
  margin: 10px 0px;
  display: inline-block;
  box-sizing: border-box;
  height: 30px;
  white-space: nowrap;
`;

export const PresentationRow = styled(Cell)`
  width: 100%;
  max-width: 100%;
  margin-top: '1.3e,';
  margin-bottom: '1.3e,';
`;

export const AnimalGroupInfo = styled(PresentationRow)`
  background-color: ${getBrandingColor(colorTypes.whiteAltBg)};
  flex-direction: column;
  padding: 15px;
  box-sizing: border-box;
  max-width: 429px;
  width: 100%;
  border-radius: 3px;
  margin-bottom: 0;
  max-width: 1000px;
  width: 100%;

  @media screen and (max-width: 650px) {
    [name='groupStatsRow1'] {
      width: 100%;
    }
  }
`;

export const LEDSheepExport = styled(AnimalGroupInfo)`
  background-color: transparent;
  font-size: 0.93rem;
  flex-direction: row;
`;

export const AnimalGroupToggleIcon = styled(Icon)`
  position: relative;
  left: 8px;
  align-self: center;
  margin-left: auto;
  margin-right: 0.75rem;
  font-size: 1.5rem;
  :hover {
    cursor: pointer;
  }
`;

export const AccountingsWrapper = styled.div`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    overflow: auto;
    min-height:600px;
  }
 
`;

export const AnmialGroupInfoItem = styled(Column)`
  flex-grow: 1;
  flex-basis: 0;
`;

export const DownloadPDFLink = styled(LinkLabel)``;
export const ExportToExcelLink = styled(LinkLabel)``;

export const StyledItemTable = styled(ItemTable)`
  td:first-child {
    width: 10em !important;
    font-weight: 600;
  }
`;

export const SheepExportTable = styled.table`
  border: 1px solid #e5e5e5;
  border-top: none;
  border-collapse: collapse;
  max-width: 957px;
  background-color: white;
  max-height: 400px;
  display: block;
  overflow: auto;

  th {
    color: white;
    background: ${getBrandingColor(colorTypes.primaryBtn)};
    padding-top: 1em;
    padding-bottom: 1em;
    padding-left: 2em;
    padding-right: 2em;
  }

  td {
    padding: 2em;
    border-top: 1px solid #e5e5e5;
    white-space: nowrap;
  }
`;

export const SheepLedExportBtnWrapper = styled.div`
  display: contents;
  @media screen and (max-width: 1200px) {
    display: none;
  }
`;

export const ContentWrapper = styled.div`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    ${(props) => (!props.isLoading ? css`max-height: 700px;` : '')}
  }
`;

export const NextPrevIcon = styled(Icon)`
  font-size: 1.7em;
  color: ${(props) => (props.locked ? 'lightgray' : 'gray')};
  :hover{
    cursor: ${(props) => (props.locked ? 'not-allowed' : 'pointer')};
  }
  visibility: ${(props) => (props.hide ? 'hidden' : 'visible')};
`;

export const SheepLedExportWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const PhotoIcon = styled(Icon)`
  margin-left: 1em;
  align-self: center;
  color: #848484;
  margin-top: 0.1em;

  :hover {
    cursor: pointer;
  }
`;

export const DateDropdownItem = ({
  item,
  searchTerm,
  itemHasFocus,
  fontSize,
}) => (
  <DropdownItem itemHasFocus={itemHasFocus} key={searchTerm}>
    <RenderPartHightlightMatch
      money
      contentWrapperStyle={{
        textAlign: 'left',
        marginLeft: '5px',
        fontSize,
      }}
      part={item.formatted}
      searchTerm={searchTerm}
    />
  </DropdownItem>
);

export const AnimalGroupTopPart = styled(PresentationRow)`
  background: transparent;
  flex-direction: row;
  max-width: 364px;
  :hover {
    cursor: pointer;
    ${AnimalGroupHeader} {
      color: ${getBrandingColor(colorTypes.linkPrimary)};
      text-decoration: none;
      border-bottom: 1.5px solid ${getBrandingColor(colorTypes.linkPrimary)};
      box-sizing: border-box;
    }
  }
`;

export const DatepickerLabel = styled.div`

`;

export const DatePickerPopupWrapper = styled.div``;
export const SelectedDateFromBtn = styled(ChoiceButton)`
  width: fit-content;
  margin-right: 1em;
  font-size: 0.85em;
`;
